import React from 'react';
import { FooterContainer, FooterWrap, FooterLinksContainer, FooterLinksWrapper, FooterLinkItems, FooterLinkTitle, FooterLink, FooterLinkTel, FooterBottom, FooterBottomWrap, FooterLogo, FooterLogoImg, WebsiteRights, WebsiteProject, WebsiteProjectsLink } from './FooterElements';
import Logo from '../../images/logo-szsem.png';
import { FaCode, FaFacebookSquare, FaEnvelope, FaUsers, FaFacebookMessenger, FaInstagram, FaPhoneAlt } from 'react-icons/fa'

const Footer = () => {
    return (
        <FooterContainer>
            <FooterWrap>
                <FooterLinksContainer>
                    <FooterLinksWrapper>
                        <FooterLinkItems>
                            <FooterLinkTitle>Stowarzyszenie</FooterLinkTitle>
                                <FooterLink href="http://stowarzyszenie.zsem.edu.pl/"><FaCode /> Strona internetowa</FooterLink>
                                <FooterLink href="https://www.facebook.com/SadeckiElektryk"><FaFacebookSquare /> Strona Facebook</FooterLink>
                                <FooterLink href="mailto: stowarzyszenie@zsem.edu.pl "><FaEnvelope /> Email</FooterLink>
                                <FooterLink href="http://stowarzyszenie.zsem.edu.pl/?page_id=54"><FaUsers /> Zarząd Stowarzyszenia</FooterLink>
                                <FooterLinkTel><FaPhoneAlt />  18 443 71 15</FooterLinkTel>
                        </FooterLinkItems>
                        <FooterLinkItems>
                            <FooterLinkTitle>ZSEM</FooterLinkTitle>
                                <FooterLink href="https://zsem.edu.pl/"><FaCode /> Strona internetowa</FooterLink>
                                <FooterLink href="https://www.facebook.com/ZSEMNS"><FaFacebookSquare /> Strona Facebook</FooterLink>
                                <FooterLink href="mailto: elektryk@edu.nowysacz.pl"><FaEnvelope /> Email</FooterLink>
                                <FooterLink href="https://www.instagram.com/zsemns/"><FaInstagram /> Instagram</FooterLink>
                                <FooterLinkTel><FaPhoneAlt />  18 443 71 15</FooterLinkTel>
                        </FooterLinkItems>
                        <FooterLinkItems>
                            <FooterLinkTitle>Kacper Filip</FooterLinkTitle>
                                <FooterLink href="https://kacperfilip.tk"><FaCode /> Strona internetowa</FooterLink>
                                <FooterLink href="https://www.messenger.com/t/100006777843570"><FaFacebookMessenger /> Messenger</FooterLink>
                                <FooterLink href="mailto: k.filip2004@gmail.com"><FaEnvelope /> Email</FooterLink>
                        </FooterLinkItems>
                    </FooterLinksWrapper>
                </FooterLinksContainer>
                <FooterBottom>
                    <FooterBottomWrap>
                        <FooterLogo href="http://stowarzyszenie.zsem.edu.pl/" >
                            <FooterLogoImg src={Logo}></FooterLogoImg>
                        </FooterLogo>
                        <WebsiteRights>
                            Copyright Kacper Filip © {new Date().getFullYear()}
                        </WebsiteRights>
                        <WebsiteProject>
                            Projekt i realizacja: 
                            <WebsiteProjectsLink href="https://www.kacperfilip.tk/">
                                Kacper Filip
                            </WebsiteProjectsLink>
                        </WebsiteProject>
                    </FooterBottomWrap>
                </FooterBottom>
            </FooterWrap>
        </FooterContainer>
    )
}

export default Footer
